import comp from "./PypEvaluation";
export default comp;
